// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-actions {
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
}

.spacer {
  flex: 1 1 auto;
}

.place-photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.moto-icon {
  margin-right: 7px;
}

.place-button {
  height: 40px;
  width: 45px;
  padding-left: 7px;
}

.z-index-5 {
  z-index: 5;
}

.container {
  background: #1b1919;
  background-size: 800% 800%;
  animation: GradientToolbarAnimation 59s ease infinite;
  color: white !important;
}
@keyframes GradientToolbarAnimation {
  0% {
    background-position: 50% 0%;
  }
  50% {
    background-position: 50% 100%;
  }
  100% {
    background-position: 50% 0%;
  }
}
.animation {
  transition: top 0.3s;
}

.home-button {
  width: 60px !important;
  height: 53px !important;
}

.home-photo {
  width: 55px;
  height: 45px;
}

.mr-15 {
  margin-right: 15%;
}

.discover-icon {
  font-size: 20px;
}

.custom-icon {
  color: #8ebbce;
}

.ml-10 {
  margin-left: 10px;
}

.container-title {
  display: flex;
  align-items: center;
}
.container-title p {
  font-size: 20px;
  font-weight: 500;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/basic/toolbar/toolbar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,0BAAA;EAGA,qDAAA;EACA,uBAAA;AACF;AAwBA;EACE;IACE,2BAAA;EACF;EACA;IACE,6BAAA;EACF;EACA;IACE,2BAAA;EACF;AACF;AAEA;EACE,oBAAA;AAAF;;AAGA;EACE,sBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;AAAE;EACE,eAAA;EACA,gBAAA;AAEJ;AAxBA,4pGAA4pG","sourcesContent":[".user-actions {\n  display: flex;\n  justify-content: center;\n  flex: 1 1 auto;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n.place-photo {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.moto-icon {\n  margin-right: 7px;\n}\n\n.place-button {\n  height: 40px;\n  width: 45px;\n  padding-left: 7px;\n}\n\n.z-index-5 {\n  z-index: 5;\n}\n\n.container {\n  background: #1b1919;\n  background-size: 800% 800%;\n  -webkit-animation: GradientToolbarAnimation 59s ease infinite;\n  -moz-animation: GradientToolbarAnimation 59s ease infinite;\n  animation: GradientToolbarAnimation 59s ease infinite;\n  color: white !important;\n}\n\n@-webkit-keyframes GradientToolbarAnimation {\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n@-moz-keyframes GradientToolbarAnimation {\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n@keyframes GradientToolbarAnimation {\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n\n.animation {\n  transition: top 0.3s;\n}\n\n.home-button {\n  width: 60px !important;\n  height: 53px !important;\n}\n\n.home-photo {\n  width: 55px;\n  height: 45px;\n}\n\n.mr-15 {\n  margin-right: 15%;\n}\n\n.discover-icon {\n  font-size: 20px;\n}\n\n.custom-icon {\n  color: #8ebbce;\n}\n\n.ml-10 {\n  margin-left: 10px;\n}\n.container-title {\n  display: flex;\n  align-items: center;\n  p {\n    font-size: 20px;\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
